// eslint-disable-next-line
export const API = 'https://mate-academy.github.io/react_phone-catalog/api';

export const BASE_URL = 'https://mate-academy.github.io/react_phone-catalog';
